export type MelonItem = {
  id: number;
  time: string;
  tag: string;
  title: string;
  summary: string;
  heat: string;
  comments: number;
};

export type LeakItem = {
  id: number;
  tag: string;
  title: string;
  summary: string;
  time: string;
  heat: string;
};

export type GossipItem = {
  id: number;
  index: string;
  question: string;
  answer: string;
  author: string;
  time: string;
};

export type TopicItem = {
  id: number;
  name: string;
  count: string;
  level: string;
};

export type RankItem = {
  id: number;
  rank: number;
  title: string;
  tag: string;
  heat: string;
  percent: number;
  trend: string;
};

export const tickerItems: string[] = [
  '今日已更新 128 条新瓜',
  '「某S+古装大剧深夜换角」冲上热搜第 2',
  '新鲜爆料：某综艺常驻阵容疑似大调整',
  '最新八卦：顶流歌手巡演加场已进入报批流程',
  '话题墙「年度最佳售后」讨论量突破 4.2 万',
  '今日瓜速递：剧组路透曝光，网友直呼信息量太大',
];

export const todayMelons: MelonItem[] = [
  {
    id: 1,
    time: '10:24',
    tag: '影视',
    title: '某S+古装大剧深夜换角，剧组凌晨发通告',
    summary: '通告发出不到两小时，相关账号接连删帖，反而让讨论量越滚越大，瓜友们已经开始拼时间线。',
    heat: '9.8w',
    comments: 2341,
  },
  {
    id: 2,
    time: '09:57',
    tag: '音乐',
    title: '顶流歌手巡回宣布加场，票务页面先崩为敬',
    summary: '加场消息刚落地，多个城市站点的候补人数迅速翻倍，究竟是安排紧凑还是临时调整，暂时没人给出准话。',
    heat: '8.6w',
    comments: 1877,
  },
  {
    id: 3,
    time: '09:31',
    tag: '综艺',
    title: '某老牌综艺被曝改版，常驻名单出现陌生面孔',
    summary: '录制路透里出现了两张从未官宣的新面孔，评论区一半在猜身份，一半在感慨「时代的眼泪」。',
    heat: '7.4w',
    comments: 1592,
  },
  {
    id: 4,
    time: '08:48',
    tag: '时尚',
    title: '红毯造型repo刷屏，同款外套十分钟售罄',
    summary: '同一件外套被两位艺人先后穿上身，谁的演绎更出圈又成了新一轮争论焦点，造型师评论区已经沦陷。',
    heat: '6.2w',
    comments: 1104,
  },
  {
    id: 5,
    time: '08:12',
    tag: '影视',
    title: '悬疑新剧放出首支预告，弹幕全程在找彩蛋',
    summary: '三十秒预告埋了至少五个可解读的细节，瓜友逐帧截图做了张对比表，据说第三条线索最接近真相。',
    heat: '5.9w',
    comments: 986,
  },
  {
    id: 6,
    time: '07:55',
    tag: '八卦',
    title: '两张同款行程图流出，巧合还是安排引发猜想',
    summary: '两张行程截图的时间地点高度重合，双方团队目前都没有回应，话题墙上的接龙已经从周一排到周五。',
    heat: '5.1w',
    comments: 1442,
  },
  {
    id: 7,
    time: '07:20',
    tag: '音乐',
    title: '新歌上线首日冲进榜单前列，评论区两极分化',
    summary: '旋律党与歌词党再次开战，有人说上头有人说听不懂，双方各执一词，倒把播放量推得更高了。',
    heat: '4.3w',
    comments: 763,
  },
  {
    id: 8,
    time: '06:40',
    tag: '综艺',
    title: '往期名场面被翻出，二创视频一晚涨粉十万',
    summary: '一段三年前的旧片段突然翻红，二次创作版本铺满首页，连当事人都悄悄给剪辑点了赞。',
    heat: '3.8w',
    comments: 621,
  },
];

export const freshLeaks: LeakItem[] = [
  {
    id: 1,
    tag: '片场',
    title: '新剧组临时改景，原定拍摄地连夜清场',
    summary: '原计划连拍一周的外景突然调整，工作人员连夜拆景，具体原因暂未对外说明。',
    time: '32 分钟前',
    heat: '热',
  },
  {
    id: 2,
    tag: '合作',
    title: '两位风格完全不同的音乐人被曝将同台',
    summary: '消息源称企划已经进入demo阶段，若成行会是今年最让人意外的组合之一。',
    time: '1 小时前',
    heat: '新',
  },
  {
    id: 3,
    tag: '商务',
    title: '某品牌代言阵容疑似更新，物料已进入内审',
    summary: '相关物料图在多个渠道反复出现又被撤下，瓜友们判断官宣窗口就在这几天。',
    time: '2 小时前',
    heat: '热',
  },
  {
    id: 4,
    tag: '综艺',
    title: '新一季嘉宾名单流出，常驻位置出现空缺',
    summary: '名单里少了一直以来的固定成员，替补人选是熟脸还是新人，目前说法不一。',
    time: '3 小时前',
    heat: '新',
  },
  {
    id: 5,
    tag: '剧集',
    title: '两部待播剧撞档，平台排期表被反复修改',
    summary: '同一档期出现两部高关注度作品，排期表前后改动至少三次，最终定档仍是悬念。',
    time: '4 小时前',
    heat: '热',
  },
  {
    id: 6,
    tag: '幕后',
    title: '资深幕后团队被曝将自立门户',
    summary: '合作多年的团队疑似分家，接下来的项目归属成了业内最关心的问题。',
    time: '5 小时前',
    heat: '新',
  },
];

export const latestGossip: GossipItem[] = [
  {
    id: 1,
    index: '01',
    question: '那场被反复解读的红毯同框，到底是谁先动的？',
    answer: '把现场三条不同机位的视频按时间排序后会发现，最先被拍到的其实是候场区的短暂交汇，正式红毯上两人几乎零交流，所谓的「互动名场面」多半是角度造成的错觉。',
    author: '瓜田里的老张',
    time: '12 分钟前',
  },
  {
    id: 2,
    index: '02',
    question: '剧组的「深夜通告」为什么总在凌晨发出？',
    answer: '圈内惯例是等当天拍摄收工、通告单确认无误后再统一发布。凌晨发出并不代表事情紧急，很多情况下只是流程走到了那一步，但时间点本身就容易被过度解读。',
    author: '蹲点小分队',
    time: '40 分钟前',
  },
  {
    id: 3,
    index: '03',
    question: '演唱会的「加场」真的是临时起意吗？',
    answer: '大多数加场在开票前就已完成报批与场地沟通，所谓临时的说法略显夸张。真正决定加场的通常是首轮售票数据与候补人数，而不是网上的呼声。',
    author: '票务观察员',
    time: '1 小时前',
  },
  {
    id: 4,
    index: '04',
    question: '为什么同一个造型会被两拨人夸到天上去？',
    answer: '造型的成败很大程度取决于现场光位与机位角度，同一套衣服在不同镜头下呈现效果相差极大。与其争论谁更好看，不如先看清拍的是哪个角度。',
    author: '时尚边角料',
    time: '2 小时前',
  },
  {
    id: 5,
    index: '05',
    question: '「疑似」「或将」这类词为什么到处都是？',
    answer: '在信息尚未落定前，谨慎措辞既是行业习惯也是自我保护。看到这类词先别急着下结论，把时间线拼完整，往往比抢第一句评论更重要。',
    author: '吃瓜守则组',
    time: '3 小时前',
  },
];

export const topicWall: TopicItem[] = [
  { id: 1, name: '古装剧换角', count: '4.2w', level: 'hot' },
  { id: 2, name: '演唱会加场', count: '3.6w', level: 'hot' },
  { id: 3, name: '红毯造型', count: '2.9w', level: 'warm' },
  { id: 4, name: '综艺改版', count: '2.4w', level: 'warm' },
  { id: 5, name: '待播剧排期', count: '1.9w', level: 'warm' },
  { id: 6, name: '新歌上线', count: '1.5w', level: 'normal' },
  { id: 7, name: '同款外套', count: '1.2w', level: 'normal' },
  { id: 8, name: '二创名场面', count: '9863', level: 'normal' },
  { id: 9, name: '幕后团队', count: '7421', level: 'normal' },
  { id: 10, name: '预告彩蛋', count: '6218', level: 'normal' },
  { id: 11, name: '行程重合', count: '5033', level: 'normal' },
  { id: 12, name: '代言物料', count: '4876', level: 'normal' },
  { id: 13, name: '片场路透', count: '3920', level: 'normal' },
  { id: 14, name: '首播口碑', count: '3105', level: 'normal' },
];

export const rankList: RankItem[] = [
  { id: 1, rank: 1, title: '某S+古装大剧深夜换角', tag: '影视', heat: '9.8w', percent: 100, trend: 'up' },
  { id: 2, rank: 2, title: '顶流歌手巡回宣布加场', tag: '音乐', heat: '8.6w', percent: 88, trend: 'up' },
  { id: 3, rank: 3, title: '综艺常驻阵容疑似调整', tag: '综艺', heat: '7.4w', percent: 76, trend: 'flat' },
  { id: 4, rank: 4, title: '红毯同款外套十分钟售罄', tag: '时尚', heat: '6.2w', percent: 63, trend: 'up' },
  { id: 5, rank: 5, title: '悬疑新剧预告藏彩蛋', tag: '影视', heat: '5.9w', percent: 60, trend: 'down' },
  { id: 6, rank: 6, title: '两张行程图高度重合', tag: '八卦', heat: '5.1w', percent: 52, trend: 'up' },
];

export const joinPoints: { id: number; icon: string; title: string; desc: string }[] = [
  { id: 1, icon: 'ri-flashlight-line', title: '新瓜速递', desc: '今日更新实时推送，热点不隔夜' },
  { id: 2, icon: 'ri-chat-3-line', title: '话题开聊', desc: '每个话题都有讨论区，观点随便摆' },
  { id: 3, icon: 'ri-bookmark-line', title: '追瓜存档', desc: '一键收藏，时间线自动拼接整理' },
  { id: 4, icon: 'ri-shield-check-line', title: '理性吃瓜', desc: '信息标注来源，未证实内容先打问号' },
];